import { GetStaticPaths, GetStaticProps } from 'next';

import {
  AllCaseStudySlugsDocument,
  AllCaseStudySlugsQuery,
  CaseStudiesDetailDocument,
  CaseStudiesDetailQuery
} from 'graphql/generated';

import CaseStudyItem from 'components/CaseStudyItem';
import DatoMeta from 'components/DatoMeta';
import DatoStructuredText from 'components/DatoStructuredText';
import Footer from 'components/Footer';
import Navigation from 'components/Navigation';
import RootContainer from 'components/RootContainer';

import { datoRequest } from 'lib/datoSDK';

import * as S from 'styles/CaseStudy.styles';

interface ICaseStudyProps {
  caseStudiesDetailQuery: CaseStudiesDetailQuery;
}

const CaseStudy = ({ caseStudiesDetailQuery }: ICaseStudyProps) => {
  if (!caseStudiesDetailQuery) {
    return null;
  }

  const caseStudy = caseStudiesDetailQuery.allCaseStudies[0];

  return (
    <>
      {caseStudy?.seo && <DatoMeta seo={caseStudy?.seo} />}

      <Navigation navItems={caseStudiesDetailQuery.allNavitems} />

      <RootContainer>
        {caseStudy && <CaseStudyItem caseStudy={caseStudy} detailsPage />}

        <S.CaseStudyContentWrapper>
          <DatoStructuredText data={caseStudy.content} />
        </S.CaseStudyContentWrapper>
      </RootContainer>

      <Footer />
    </>
  );
};

export const getStaticPaths: GetStaticPaths = async () => {
  const caseStudySlugs = await datoRequest<AllCaseStudySlugsQuery>(AllCaseStudySlugsDocument);
  const slugs = caseStudySlugs.allCaseStudies
    .map((cs) => cs.slug)
    .filter((slug) => slug) as string[];

  return {
    paths: slugs.map((slug) => ({ params: { slug } })),
    fallback: true
  };
};

export const getStaticProps: GetStaticProps = async ({ params }) => {
  const slug = params?.slug?.toString() || '';

  try {
    const caseStudiesDetailQuery = await datoRequest<CaseStudiesDetailQuery>(
      CaseStudiesDetailDocument,
      { slug }
    );

    return {
      props: {
        caseStudiesDetailQuery
      },
      revalidate: 1
    };
  } catch {
    return { notFound: true };
  }
};

export default CaseStudy;
